// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageBroadcasts_overlayWrapper__QKimH","viewBox":"ManageBroadcasts_viewBox__1LbWY","tablestyle":"ManageBroadcasts_tablestyle__8swQY"};